export const DocumentTypes = {
    PhotoIdentityProof: 1,
    AddressProof: 2,
    IncomeProof: 3,
    SignatureProof: 4,
    AcademicCertificates: 5,
    BankStatementProof: 6,
    Miscellaneous: 7,
    ProfilePictures: 8
};